import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';

import { FeatureContentLayoutComponent } from '@unico-people/shared/dashboard/feature-content-layout';
import { EmployeeCallbackComponent } from '@unico-people/ongoing';

import { AuthGuardService } from '@unico-people/shared/dashboard/data-access-auth';
import { DataAccessModulesGuard } from '@unico-people/shared/dashboard/data-access-modules';

import { DataAccessOrganizationsGuard } from '@unico-people/shared/dashboard/data-access-organizations';

const appRoutes: Routes = [
  {
    path: 'callback',
    component: EmployeeCallbackComponent,
    data: { roles:'ongoing'},
  },
  { path: 'preauthorize',
    component: EmployeeCallbackComponent,
    data: { roles:'ongoing'},
   },
  {
    path: '',
    component: FeatureContentLayoutComponent,
    canActivate: [AuthGuardService, DataAccessModulesGuard],
    data: { roles:'ongoing'},
    children: [
      {
        path: '',
        redirectTo: 'all',
        pathMatch: 'full'
      },
      {
        path: 'all',
        canActivate: [DataAccessOrganizationsGuard],
        loadChildren: () => import('@unico-people/ongoing').then(m => m.EmployeeListModule)
      },
      {
        path: 'profile',
        canActivate: [DataAccessOrganizationsGuard],
        loadChildren: () => import('@unico-people/ongoing').then(m => m.EmployeeProfileModule)
      },
      {
        path: 'new',
        loadChildren: () => import('@unico-people/ongoing').then(m => m.EmployeeImportModule)
      },
      {
        path: 'listing',
        loadChildren: () => import('@unico-people/benefits').then(m => m.BenefitsListingModule)
      },
      {
        path: 'shipping',
        loadChildren: () => import('@unico-people/ongoing').then(m => m.EnvelopeShippingDocumentsModule)
      },
      {
        path: 'processing-status',
        loadChildren: () => import('@unico-people/ongoing').then(m => m.EmployeeStatusModule)
      },
      {
        path: 'requests',
        loadChildren: () => import('@unico-people/ongoing').then(m => m.EmployeeRequestsModule)
      }
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {
      preloadingStrategy: PreloadAllModules,
      relativeLinkResolution: 'legacy'
    })
  ],
  exports: [RouterModule],
  providers: [AuthGuardService, DataAccessOrganizationsGuard]
})
export class AppRoutingModule {}
